export const ADD_RECORD_TIME = 'ADD_RECORD_TIME';
export const SET_RECORD_TIME = 'SET_RECORD_TIME';
export const ADD_WORK_SOCIAL_ADJUSTMENT_SCALE = 'ADD_WORK_SOCIAL_ADJUSTMENT_SCALE';
export const SET_WORK_SOCIAL_ADJUSTMENT_SCALE = 'SET_WORK_SOCIAL_ADJUSTMENT_SCALE';
